/**
 * @ngInject
 */
function HelpDialogCtrl($mdDialog){
	var ctrl = this;
	
	ctrl.hide = function() {
		$mdDialog.hide();
	};
	ctrl.cancel = function() {
      $mdDialog.cancel();
    };
}